import { Entity } from '@cervotech/types/api';

export function isNewEntity(entity: Entity | Entity['id']): boolean {
  if (typeof entity === 'object') {
    return entity.id === 'new';
  }
  return entity === 'new';
}
